import axios from "axios";
import { baseURL } from "@/general";

const adminApi = axios.create({
  baseURL,
});

export const insertInvestigator = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/investigador/insertInvestigador",
      values,
      config
    );
    return response;
  } catch (error) {
    const response = error.response;
    return response;
  }
};

export const InsertEvaluacion = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "encuesta/insertEncuestaInvestigador",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response.data;
    return response;
  }
};


export const traeConstancias = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/investigador/getEstanciasBySemestre",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response.data;
    return response;
  }
};


export const constanciaTitular = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/general/generarConstanciaPrincipal",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response.data;
    return response;
  }
};



export const constanciaAdjunto = async (values) => {
  let token = localStorage.getItem("session_id");
  const config = {
    headers: {
      "x-api-key": token,
    },
  };
  try {
    const response = await adminApi.post(
      "/general/generarConstanciaAdjunto",
      values,
      config
    );
    return response.data;
  } catch (error) {
    const response = error.response.data;
    return response;
  }
};


